import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Warranty } from '../../models/warranty-type/warranty-model';
import { ProductService } from '../../services/product/product.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-warranty-edit',
    templateUrl: './warranty-edit.component.html',
    styleUrls: ['./warranty-edit.component.css']
})
/** warranty-edit component*/
export class WarrantyEditComponent {
    /** warranty-edit ctor */
  public warranty = new Warranty();
  validate: boolean;
  constructor(private readonly productService: ProductService, public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService, private _avRoute: ActivatedRoute) {
    this.rolePermissionService.GetRolePermissions("warrantyType").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            if (this._avRoute.snapshot.params["id"]) {
              this.getWarrantyById(this._avRoute.snapshot.params["id"]);
              this.toastr.setRootViewContainerRef(vcr);
            }
            this.validate = true;

          }
          else {
            this.router.navigate(["/warranty-list"]);
          }
        }
        else {
          this.router.navigate(["/warranty-list"]);
        }
      }
    )

  }
  getWarrantyById(id: string) {
    this.productService.getWarrantyById(id).subscribe(
      data => {
        this.warranty = data;
      }
    )
  }
  isActiveCheckbox(e) {
    this.warranty.isActive = e.target.checked;
  }
  onSubmit() {
    this.validate = false;
    this.productService.updateWarranty(this.warranty).subscribe(result => {
      if (result) {
        this.toastr.success('Warranty Type has been Update.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/warranty-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Please try again', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/warrantyType/warranty-edit/warranty-edit.component.ts